class Document {
  constructor({ id, _id, url }) {
    this.id = id || _id;
    this.url = url;
  }
}

export default Document;
